import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { SinglePlayer } from '../../../Api/Players/models';
import { EditPasswordModal } from './EditPasswordModal';
import { patchPlayer } from '../../../Api/Players/Players';
import { BsChatLeftText } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

interface EditPlayerModalProps {
    show: boolean;
    onHide: () => void;
    player: SinglePlayer | null;
}

export const EditPlayerModal = ({ show, onHide, player }: EditPlayerModalProps) => {
    const navigate = useNavigate()
    const [editPassword, setEditPassword] = useState(false)
    const [form, setForm] = useState<any>({
        id: player?.id || '',
        firstName: player?.firstName || '',
        lastName: player?.lastName || '',
        email: player?.email || '',
        phone: player?.phone || '',
        platformUser: player?.platformUser || '',
        newPassword: '',
    });

    const handleSubmit = async () => {
        const res = await patchPlayer(form)
        if (res?.success) {
            onHide();
        }
    };

    useEffect(() => {
        if (player) {
            setForm({
                id: player.id,
                firstName: player.firstName,
                lastName: player.lastName,
                email: player.email,
                phone: player.phone,
                platformUser: player.platformUser,
            });
        }
    }, [player]);

    return (
        <>

            <EditPasswordModal
                show={editPassword}
                onHide={() => setEditPassword(false)}
                player={player}
            />
            <Modal show={show} onHide={onHide} centered>
                <div className="border border-secondary rounded-3">
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Jugador {player?.platformUser}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <Form>

                            <div className='mb-3 d-flex justify-content-between align-items-center'>
                                <div className='d-flex flex-column align-items-start'>
                                    <Form.Label>Usuario de la plataforma</Form.Label>
                                    <span className='text-primaryy'>{player?.platformUser}</span>
                                </div>

                                <div className='mt-2 d-flex justify-content-end'>
                                    <Button variant='primary'
                                        className='d-flex align-items-center gap-2'
                                        onClick={() => navigate(`/dashboard/chat?playerId=${player?.id}`)}
                                    >
                                        <BsChatLeftText size={18} />
                                        Iniciar chat
                                    </Button>
                                </div>
                            </div>
                            <Form.Group className="mb-3" controlId="formBasicCBU">
                                <Form.Label>Nombre</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el nombre" value={form.firstName} onChange={(e) => setForm({ ...form, firstName: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicAlias">
                                <Form.Label>Apellido</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el apellido" value={form.lastName} onChange={(e) => setForm({ ...form, lastName: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicTitular">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicHourLimit">
                                <Form.Label>Teléfono</Form.Label>
                                <Form.Control type="text" placeholder="Ingrese el teléfono" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                            </Form.Group>
                        </Form>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className='d-flex justify-content-between w-100'>
                            <div>
                                <Button variant="secondary" onClick={() => setEditPassword(!editPassword)}>
                                    Cambiar Contraseña
                                </Button>
                            </div>

                            <div className='d-flex gap-2'>
                                <Button variant="secondary" onClick={onHide}>
                                    Cancelar
                                </Button>
                                <Button variant="primary" onClick={handleSubmit}>
                                    Guardar
                                </Button>
                            </div>
                        </div>
                    </Modal.Footer>
                </div>
            </Modal>
        </>

    );
};
